import { useEffect } from 'react';

import { useEvent } from '@bizzabo/entities';

const DEFAULT_FAVICON =
    'https://s3.amazonaws.com/bizzabo.images/events/favicons/bizzabo_favicon.ico';

const useEventFavicon = (eventUniqueName: string) => {
    const { data } = useEvent(eventUniqueName);

    useEffect(() => {
        if (!data) {
            return;
        }

        const faviconUrl = data?.faviconUrl;
        const faviconElement = document.getElementById('favicon') as HTMLLinkElement;
        const canSetFavicon = faviconElement?.href;

        if (canSetFavicon) {
            faviconElement.href = faviconUrl || DEFAULT_FAVICON;
        }
    }, [data]);
};

export default useEventFavicon;
